import { Link } from "react-router-dom";

export default function ClientRecentMessages({ messages = [] }) {
  return (
    <div className="client-card">
      <h2>Recent Messages</h2>
      {messages.length === 0 ? (
        <div className="empty-state"><h3>No new messages</h3><p>Everything is up to date.</p></div>
      ) : messages.map((message) => (
        <Link key={message.id} className="message" to={`/messages/${message.conversation_id || ""}`}>
          <strong>{message.sender_name}</strong>
          <p>{message.message}</p>
        </Link>
      ))}
    </div>
  );
}